import { TargetingValues } from '@provider-portal/common/api/openapi_gen/deliveryProviderPortal/deliveryProviderPortal/apis';
import { getType } from 'typesafe-actions';

import { NetworkRequestState } from '@bolteu/redux-session';

import { requestTargetingParametersAsyncAction, TargetingParametersActions } from './actions';

export interface TargetingParametersState {
  parameters: TargetingValues | null;
  fetchingState: NetworkRequestState;
  isDoingSafeRefresh: boolean;
  error?: Error;
}

const initialState: TargetingParametersState = {
  parameters: null,
  fetchingState: NetworkRequestState.unset,
  isDoingSafeRefresh: false,
};

export const targetingParametersReducer = (
  state: TargetingParametersState = initialState,
  action: TargetingParametersActions,
): TargetingParametersState => {
  switch (action.type) {
    case getType(requestTargetingParametersAsyncAction.request): {
      return {
        ...state,
        parameters: action.payload.safeRefresh ? state.parameters : null,
        isDoingSafeRefresh: !!action.payload.safeRefresh,
        fetchingState: NetworkRequestState.waiting,
      };
    }
    case getType(requestTargetingParametersAsyncAction.success): {
      return {
        ...state,
        parameters: action.payload.parameters,
        isDoingSafeRefresh: false,
        fetchingState: NetworkRequestState.success,
      };
    }
    case getType(requestTargetingParametersAsyncAction.failure): {
      return {
        ...state,
        isDoingSafeRefresh: false,
        fetchingState: NetworkRequestState.failure,
      };
    }

    default: {
      return state;
    }
  }
};
